module.exports = __webpack_public_path__ + "img/c3.26fbfd1f.jpg";